import React, { useState, useContext } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { styled } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface IStepProps {
  shareWith: string[];
  setShareWith: any;
}

const CustomSelect = styled(Select)({
  '.MuiSelect-icon': {
    color: '#BDBEC1'
  },
  'overflow': 'hidden',
  'color': 'var(--Text-Main, #EFF1F6)',
  'textOverflow': 'ellipsis',
  'fontFamily': 'Inter',
  'fontSize': '16px',
  'fontStyle': 'normal',
  'fontWeight': 400,
  'lineHeight': '24px',
  'borderRadius': '8px',
  'border': '1px solid #2E3036'
});

const ShareStep: React.FC<IStepProps> = (props: IStepProps) => {
  const { shareWith, setShareWith } = props;
  const { userOpts } = useContext(GlobalContext);

  const addEmailField = () => {
    setShareWith([ ...shareWith, '' ]);
  };

  const handleEmailChange = (index: number, value: string) => {
    const updatedEmails = [ ...shareWith ];
    updatedEmails[index] = value;
    setShareWith(updatedEmails);
  };

  const removeEmailField = (index: number) => {
    const updatedEmails = shareWith.filter((_, i) => i !== index);
    setShareWith(updatedEmails);
  };

  return(
    <>
      <div className='bill-container-fit-screen-content' style={{ gap: '10px', height: '450px', maxHeight: '450px', overflowY: 'auto' }}>
        <p>Do you want to share ticket details with anyone else?</p>
        {shareWith.map((email, index) => (
          <div key={index} className='bill-container-fit-screen-content-dropdown-input-sec'>
            <FormControl sx={{ width: '100%' }}>
              <CustomSelect
                value={shareWith[index]}
                onChange={(e: any) => handleEmailChange(index, e.target.value)}
                fullWidth
                IconComponent={KeyboardArrowDownIcon}
                inputProps={{
                  MenuProps: {
                    MenuListProps: {
                      sx: {
                        backgroundColor: '#202227',
                        color: 'var(--Text-Main, #EFF1F6)',
                      }
                    }
                  }
                }}
              >
                <MenuItem value=''>
                  <em>Select One</em>
                </MenuItem>
                {userOpts.map((user: any, i: number) => (
                  <MenuItem key={i} value={user.label}>{user.label}</MenuItem>
                ))}
              </CustomSelect>
            </FormControl>

            <svg style={{ cursor: 'pointer' }} onClick={() => removeEmailField(index)} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <g id='trash-03'>
                <path id='Icon' d='M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
              </g>
            </svg>
          </div>
        ))}
        <div className='bill-container-fit-screen-content-add' onClick={addEmailField}>
            + Add email
        </div>
      </div>
    </>
  );
};
export default ShareStep;
